{
  "name": "case-management-system-ui",
  "version": "1.2.1",
  "scripts": {
    "ng": "ng",
    "start": "node --max_old_space_size=5000 ./node_modules/@angular/cli/bin/ng serve",
    "build": "node --max_old_space_size=5000 ./node_modules/@angular/cli/bin/ng build --configuration production && npm run uuid",
    "prod": "node --max_old_space_size=5000  ./node_modules/@angular/cli/bin/ng build --configuration production && npm run version",
    "test": "ng test --browsers=Chrome ",
    "test:local": "ng test --karma-config karma.conf.local.js",
    "test:ci": "ng test  --browsers ChromeHeadless",
    "lint": "ng lint",
    "e2e": "ng e2e",
    "stats": "ng build --configuration production --stats-json",
    "bundle-report": "webpack-bundle-analyzer dist/Secca/stats.json",
    "version": "node_modules/.bin/replace-env src/environments/build.txt",
    "uuid": "uuid > dist/case-management-system-ui/build.txt"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^19.2.14",
    "@angular/cdk": "^19.2.19",
    "@angular/common": "19.2.14",
    "@angular/compiler": "19.2.14",
    "@angular/core": "19.2.14",
    "@angular/forms": "19.2.14",
    "@angular/google-maps": "^18.2.14",
    "@angular/localize": "^19.2.14",
    "@angular/material": "^19.2.19",
    "@angular/platform-browser": "19.2.14",
    "@angular/platform-browser-dynamic": "19.2.14",
    "@angular/router": "19.2.14",
    "@danielmoncada/angular-datetime-picker": "^19.1.2",
    "@danielmoncada/angular-datetime-picker-moment-adapter": "^6.0.2",
    "@ng-bootstrap/ng-bootstrap": "^18.0.0",
    "@ng-select/ng-select": "^14.9.0",
    "@ngbracket/ngx-layout": "15.1.3",
    "@ngx-translate/core": "^14.0.0",
    "@ngx-translate/http-loader": "^7.0.0",
    "@popperjs/core": "^2.11.8",
    "@tinkoff/ng-dompurify": "^4.0.0",
    "@tinymce/tinymce-angular": "5.0.1",
    "@types/google.maps": "3.58.1",
    "bootstrap": "^5.3.7",
    "core-js": "^3.30.2",
    "dinero.js": "^1.9.1",
    "dompurify": "^2.3.5",
    "event-source-polyfill": "^1.0.31",
    "file-saver-es": "^2.0.5",
    "flag-icons": "^7.5.0",
    "heic2any": "0.0.3",
    "keycloak-angular": "^19.0.2",
    "keycloak-js": "20.0.1",
    "lodash-es": "^4.17.21",
    "moment-timezone": "^0.5.48",
    "ng-click-outside2": "^10.0.4",
    "ng-multiselect-dropdown": "1.0.0",
    "ng2-pdf-viewer": "8.0.1",
    "ngx-currency": "^19.0.0",
    "ngx-mask": "^14.3.3",
    "ngx-webstorage": "^19.0.1",
    "on-change": "^2.0.1",
    "pdfjs-dist": "2.11.338",
    "rxjs": "^7.8.1",
    "tinymce": "^5.4.1",
    "tslib": "^2.8.1",
    "typescript": "5.8.3",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^19.2.15",
    "@angular/cli": "^19.2.15",
    "@angular/compiler-cli": "19.2.14",
    "@angular/language-service": "19.2.14",
    "@types/dinero.js": "^1.6.5",
    "@types/dompurify": "^2.3.3",
    "@types/file-saver": "^2.0.1",
    "@types/jasmine": "~3.6.0",
    "@types/jasminewd2": "^2.0.8",
    "@types/lodash": "^4.14.157",
    "@types/node": "^12.11.1",
    "codelyzer": "^6.0.2",
    "jasmine-core": "~4.6.0",
    "jasmine-spec-reporter": "~5.0.0",
    "karma": "^6.4.1",
    "karma-chrome-launcher": "~3.1.0",
    "karma-coverage": "2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "^2.0.0",
    "karma-junit-reporter": "^2.0.0",
    "protractor": "~7.0.0",
    "puppeteer": "^1.20.0",
    "replace-env": "^1.0.4",
    "ts-node": "~7.0.0",
    "tslint": "~6.1.0",
    "webpack-bundle-analyzer": "^4.5.0",
    "uuid": "^13.0.0"
  }
}
